<template>
  <loader v-bind="{ loading }">
    <columns>
      <column class="is-narrow">
        <pager context="Route" button-class="is-rounded" :pageable="routes" @nav="goTo" jump-controls/>
      </column>
      <column>
        <search-bar 
          v-model="filters.search"
          @run-search="runSearch"
          @clear-search="clearSearch"
        />
      </column>
    </columns>

    <index-row
      v-for="route in routes.data" :key="route.id"
      :title="route.uri"
      :route="{
        name: 'route-manager',
        params: {
          ...$route.params,
          route: route.id
      }}">
      <p class="help">
        <span>{{ route.method }}, last updated {{ route.updated_at | asCalendar }}</span>
      </p>

      <template #right>
        <problems column :count="route.unresolved_findings_count"/>
      </template>
    </index-row> 
    <pager context="Route" button-class="is-rounded" :pageable="routes" @nav="goTo" jump-controls/>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'EnvironmentRoutes',

  data: () => ({
    routes: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Routes')
  },

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadRoutes()
  },

  methods: {
    loadRoutes() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({data}) => {
        this.routes = data
        this.loading = false
      }, error => this.loading = false)
    },
    goTo(path) {
      this.$router.push(path)
    },
    runSearch() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'environment-routes',
        params: this.$route.params,
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environment-routes',
        params: this.$route.params,
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadRoutes'
  }
}
</script>
